import { useMemo } from 'react';
import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

const APP_PLATFORM_OPTIONS = [
  { id: 'ios', name: 'iOS' },
  { id: 'android', name: 'Android' },
];

interface AppPlatformFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const AppPlatformFilter: React.FC<AppPlatformFilterProps> = ({
  label = 'App Platform',
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? value.split(',').filter(Boolean) : [];
  const options = useMemo(() => APP_PLATFORM_OPTIONS, []);

  if (valueOnly) {
    return selectedValues.length > 0 ? <>{selectedValues.join(', ')}</> : null;
  }

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option?.name || ''}
      value={selectedValues.map((id) => options.find((o) => o.id === id))}
      onChange={(_, newValue) => setValue(newValue.map((v) => v.id).join(','))}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={!selectedValues.length ? 'Any' : ''}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip label={option?.name || ''} key={key} {...tagProps} />;
        })
      }
    />
  );
};
